module.exports = __webpack_public_path__ + "img/noble-level2-img.61896652.png";